import script from "./UiScheduleCell.vue?vue&type=script&setup=true&lang=js"
export * from "./UiScheduleCell.vue?vue&type=script&setup=true&lang=js"

import "./UiScheduleCell.vue?vue&type=style&index=0&id=9906ffdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9906ffdc"]])

export default __exports__